
export default [
    { key: 0, value: "Job" },
    { key: 1, value: "Resource" },
    { key: 2, value: "Account" },
    { key: 3, value: "Item" },
]

